module.exports = __webpack_public_path__ + "img/cards.c6ebd66f.gif";